export default __webpack_public_path__ + "static/Visiomate_Distribution_Utility-a1a52d7a4eddb1c2a85d1160f9bc123b.pdf";